import { percentage } from '../utils/numberUtils'

export default {
  methods: {
    percentageInt: (value) => {
      return percentage(value / 100) + '%'
    }
  }
}
